import { isTrackCaptionKind } from './chunk-GHCUWWGF.js';
import { $ariaBool } from './chunk-EVP5E6AO.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { effect, peek } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';
import { listenEvent, createDisposalBin } from 'maverick.js/std';
import { CaptionsRenderer, renderVTTCueString, updateTimedVTTCueNodes } from 'media-captions';

var CaptionsTextRenderer = class {
  constructor(_renderer) {
    this.L = _renderer;
    this.priority = 10;
    this.m = null;
    this.$ = createDisposalBin();
  }
  attach() {
  }
  canRender() {
    return true;
  }
  detach() {
    this.$.empty();
    this.L.reset();
    this.m = null;
  }
  changeTrack(track) {
    if (!track || this.m === track)
      return;
    this.$.empty();
    if (track.readyState < 2) {
      this.L.reset();
      this.$.add(
        listenEvent(track, "load", () => this.ce(track), { once: true })
      );
    } else {
      this.ce(track);
    }
    this.$.add(
      listenEvent(track, "add-cue", (event) => {
        this.L.addCue(event.detail);
      }),
      listenEvent(track, "remove-cue", (event) => {
        this.L.removeCue(event.detail);
      })
    );
    this.m = track;
  }
  ce(track) {
    this.L.changeTrack({
      cues: [...track.cues],
      regions: [...track.regions]
    });
  }
};

// src/player/ui/captions/captions.tsx
var Captions = class extends Component {
  onAttach() {
    this.a = useMedia();
    this.setAttributes({
      "aria-hidden": $ariaBool(this.v.bind(this))
    });
  }
  onConnect(el) {
    this.L = new CaptionsRenderer(el);
    this.ta = new CaptionsTextRenderer(this.L);
    effect(this.qh.bind(this));
  }
  onDisconnect() {
    if (this.ta) {
      this.ta.detach();
      this.a.textRenderers.remove(this.ta);
    }
    this.L?.destroy();
  }
  v() {
    const { textTrack } = this.a.$store, track = textTrack();
    return !track || !isTrackCaptionKind(track);
  }
  qh() {
    const { viewType } = this.a.$store;
    if (viewType() === "audio") {
      return this.rh();
    } else {
      return this.sh();
    }
  }
  rh() {
    effect(this.Gc.bind(this));
    return () => {
      this.el.textContent = "";
    };
  }
  Gc() {
    if (this.v())
      return;
    const { textTrack } = this.a.$store;
    listenEvent(textTrack(), "cue-change", this.th.bind(this));
    effect(this.uh.bind(this));
  }
  th() {
    this.el.textContent = "";
    const { currentTime, textTrack } = this.a.$store, time = peek(currentTime), activeCues = peek(textTrack).activeCues;
    for (const cue of activeCues) {
      const cueEl = document.createElement("div");
      cueEl.setAttribute("part", "cue");
      cueEl.innerHTML = renderVTTCueString(cue, time);
      this.el.append(cueEl);
    }
  }
  uh() {
    const { currentTime } = this.a.$store;
    updateTimedVTTCueNodes(this.el, currentTime());
  }
  sh() {
    effect(this.vh.bind(this));
    effect(this.wh.bind(this));
    this.a.textRenderers.add(this.ta);
    return () => {
      this.el.textContent = "";
      this.ta.detach();
      this.a.textRenderers.remove(this.ta);
    };
  }
  vh() {
    this.L.dir = this.$props.textDir();
  }
  wh() {
    if (this.v())
      return;
    const { currentTime } = this.a.$store;
    this.L.currentTime = currentTime();
  }
};
Captions.el = defineElement({
  tagName: "media-captions",
  props: { textDir: "ltr" }
});

export { Captions };
